module.exports = __webpack_public_path__ + "assets/5-sales-manager-jobs.261c09ab.png";